import { images } from "../../../Assets/assetsHelper";
import AddSchoolForm from "../../../Components/Organisms/Forms/AddSchoolForm/AddSchoolForm";
import "./AddSchool.css";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { MoonLoader } from "react-spinners";

function AddSchool({
  Edit = false,
  school = null,
  loading = false,
  url,
  EditSelf = false,
}) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <SchoolIcon />
            </div>
            <div className="titleContent">
              <h1>
                {Edit
                  ? EditSelf
                    ? "Edit My Information"
                    : "Edit School Information"
                  : "Add New School"}
              </h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {loading && Edit ? (
              <div className="loadingBox">
                <MoonLoader color="#012369" size={40} />
              </div>
            ) : (
              <AddSchoolForm
                Edit={Edit}
                school={school}
                url={url}
                EditSelf={EditSelf}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the school profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddSchool;
